export const payerTypes = [
  "User",
  "MemberGroup",
]

export const payeeTypes = [
  "User",
  "MemberGroup",
  "Shop",
]

export const paymentTypes = [
  "joining_fee",
  "event_fee",
  "StorePayment",
  "reimbursement",
  "membership_fee",
  "other_fee",
]
